<template>
    <div>
        <el-dialog
            :visible.sync="dialogVisible"
            class="prev-box"
            :fullscreen="true"
            width="100%"
            height="100%"
            @close="closeDialog"
            :show-close="false"
        >
            <div slot="title" class="dialog-title">
                <el-button
                    size="medium"
                    style="width: 70px; height: 36px; background: #e84932; color: #ffffff"
                    @click="backBtn"
                    >返回
                </el-button>
            </div>
            <file-preview :url="src" />
<!--            <iframe-->
<!--                :src="src"-->
<!--                frameborder="0"-->
<!--                ref="mainIframe"-->
<!--                class="fixed-iframe"-->
<!--                v-if="src"-->
<!--            ></iframe>-->
        </el-dialog>
    </div>
</template>

<script>
import FilePreview from '@/utils/FilePreview.vue'
export default {
    props: ['dialogVisible', 'src'],
    components: {
        FilePreview
    },
    methods: {
        closeDialog() {
            this.$emit('closeDialog', false)
        },
        backBtn() {
            this.$emit('closeDialog', false)
        }
    }
}
</script>

<style scoped lang="scss">
.prev-box {
    height: 100vh;

    ::v-deep .el-dialog {
        height: 100%;
        display: flex;
        flex-direction: column;

        .el-dialog__header {
            padding: 10px 20px 0;
        }

        .el-dialog__body {
            height: 1%;
            flex: 1;
        }
    }

    .dialog-title {
        display: flex;
        justify-content: space-between;

        span {
            margin: 0px auto;
        }
    }

    .fixed-iframe {
        width: 100%;
        height: 100%;
    }

    .ep-tmpl {
        width: 100%;
        height: 100%;
        background-color: #fff;

        .paper-wrapper {
            ::v-deep .el-scrollbar__wrap {
                overflow-x: hidden;
            }
        }

        .paper-container {
            background-color: #fff;
            width: 100%;

            .paper-title {
                width: 100%;
                text-align: center;
                font-size: 24px;
                color: #409eff;
                font-weight: 600;
            }

            .paper-content {
                margin-top: 20px;
                padding: 0 20px;
            }
        }
    }
}
</style>
